import { useBreakpointValue } from '@chakra-ui/react'

export function openFullscreen() {
  document.documentElement.requestFullscreen()
}

export function closeFullscreen() {
  document.exitFullscreen()
}

export function useBreakpoint() {
  return useBreakpointValue({ base: 0, sm: 1, md: 2, lg: 3, xl: 4, '2xl': 5 }, { ssr: false }) || 0
}
